const initState = {};
const ChildCustomViewReducer = (state = initState, action) => {
    switch(action.type) {
        case  'ChildCustomViewAction' : return  action.payload ;
        default: return state;
    }
}
export default ChildCustomViewReducer;